import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Index from "./pages/Index";
import SignalAssessment from "./components/assessment/SignalAssessment";
// import UserDetailsPage from "./components/UserDetailsPage";
import SignalAIUserDetails from "./components/SignalAIUserDetails";
// import OtpVerificationPage from "./components/OtpVerificationPage";
import SignalAIOTPVerification from "./components/SignalAIOTPVerification";
import SignalAIThankYou from "./components/SignalAIThankYou";
import ReportPage from "./components/report/pdf";
// import ThankYouPage from "./components/ThankYouPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/home" element={<SignalAssessment />} />
        <Route path="/assessment" element={<SignalAssessment />} />
        {/* <Route path="/user-details" element={<UserDetailsPage />} /> */}
        <Route path="/signalai-user-details" element={<SignalAIUserDetails />} />
        <Route path="/signalai-otp-verification" element={<SignalAIOTPVerification />} />
        <Route path="/signalai-thank-you" element={<SignalAIThankYou />} />
        <Route path="/report" element={<ReportPage />} />
        {/* <Route path="/otp-verification" element={<OtpVerificationPage />} /> */}
        {/* <Route path="/thank-you" element={<ThankYouPage />} /> */}
      </Routes>
    </Router>
  );
}

export default App; 